import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import i18n from 'simple-react-i18n'
import { push } from 'react-router-redux'
import SignUpValidationActions from '../actions/SignUpValidationActions'
import { PATH_LOGIN } from '../../home/constants/HomeConstants'
import BetaBanner from '../../components/banner/BetaBanner'

const toastr = window.toastr

class SignUpValidationApp extends Component {

	constructor(props) {
		super(props)
		this.state = {
			error: '',
			success: '',
			captcha: false,
			user: {
				login: '',
				password: '',
				lastname: '',
				firstname: '',
				mobile: '',
				phone: '',
				address: '',
				city: '',
				postalCode: ''
			}
		}
	}

	componentWillMount() {
		if (!this.props.location.query.token) {
			AppStore.dispatch(push(PATH_LOGIN))
		} else {
			const login = atob(this.props.location.query.token).split(' ')[0]
			this.setState({ user: Object.assign({}, this.state.user, { login: login }) })
		}
	}

	componentDidUpdate() {
		if (this.state.error) {
			toastr.error(this.state.error, '', { positionClass: 'toast-bottom-right' })
		}
		if (this.state.success) {
			toastr.success(this.state.success, '', { positionClass: 'toast-bottom-right' })
		}
	}

	handleChange = (event) => {
		this.setState({ user: Object.assign({}, this.state.user, { [event.target.name]: event.target.value }) })
	}

	onSubmit = (event) => {
		event.preventDefault()
		AppStore.dispatch(SignUpValidationActions.signUpValidation(this.state.user, this.props.location.query.token))
	}

	render() {
		return (
			<div>
				<div className='container-div'>
					<BetaBanner/>
					<div className='container-panel'>
						<div className='row'>
							<div className='valign-wrapper'>
								<div className='center col l12 m12 s12'>
									<img src='/public/pictures/logo.png' className='imgAquaDB'/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col l12 m12 s12'>
								<div className='col l10 m12 s12 offset-l1 offset-m1 offset-s1 card registerCard z-depth-1'>
									<div className='row card-content no-padding cardLogin'>
										<h5 className='center titleCard'>{ i18n.signup.toUpperCase() }</h5>
										<form className='col l12 m12 s12' onSubmit={ this.onSubmit }>
											<div className='row'>
												<div className='input-field col l6 m12 s12'>
													<input ref='login' disabled name='login' type='text' value={ this.state.user.login } className='validate'/>
													<label htmlFor='login'>{ i18n.login }</label>
												</div>
												<div className='input-field col l6 m12 s12'>
													<input value={ this.state.user.password } onChange={ this.handleChange } name='password' type='password' className='validate'/>
													<label htmlFor='login'>{ i18n.password }</label>
												</div>
												<div className='input-field col l6 m12 s12'>
													<input value={ this.state.user.lastname } onChange={ this.handleChange } name='lastname' type='text' className='validate'/>
													<label htmlFor='lastname'>{ i18n.lastname }</label>
												</div>
												<div className='input-field col l6 m12 s12'>
													<input value={ this.state.user.firstname } onChange={ this.handleChange } name='firstname' type='text' className='validate'/>
													<label htmlFor='firstname'>{ i18n.firstname }</label>
												</div>
												<div className='input-field col l6 m12 s12'>
													<input value={ this.state.user.mobile } onChange={ this.handleChange } name='mobile' type='text' className='validate'/>
													<label htmlFor='mobile'>{ i18n.mobile }</label>
												</div>
												<div className='input-field col l6 m12 s12'>
													<input value={ this.state.user.phone } onChange={ this.handleChange } name='phone' type='text' className='validate'/>
													<label htmlFor='phone'>{ i18n.phone }</label>
												</div>
												<div className='input-field col l12 m12 s12'>
													<input value={ this.state.user.address } onChange={ this.handleChange } name='address' type='text' className='validate'/>
													<label htmlFor='address'>{ i18n.address }</label>
												</div>
												<div className='input-field col l4 m12 s12'>
													<input value={ this.state.user.postalCode } onChange={ this.handleChange } name='postalCode' type='text' className='validate'/>
													<label htmlFor='address'>{ i18n.zip }</label>
												</div>
												<div className='input-field col l8 m12 s12'>
													<input value={ this.state.user.city } onChange={ this.handleChange } name='city' type='text' className='validate'/>
													<label htmlFor='city'>{ i18n.city }</label>
												</div>
												<div className='input-field col l12 m12 s12 offset-m1 offset-s1'>
													<u>
														<button to='dashboard' className='waves-effect col l12 m12 s12 waves-light btn'>{ i18n.signup }</button>
													</u>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

SignUpValidationApp.propTypes = {
	location: PropTypes.shape({
		query: PropTypes.shape({
			token: PropTypes.string
		})
	})
}

export default SignUpValidationApp



// WEBPACK FOOTER //
// ./src/signup/components/SignUpValidationApp.js